import Table from 'components/table';
import styles from './productTable.module.scss';

// This is strictly a two-column table, left over from a previous implementation. It has since been
// unified with the Table components we use elsewhere on the site, and could stand to be updated to be a
// more generic table PortableText block component at some point.
export default function ProductTable({ value }: ProductTableProps) {
	return (
		<div className={styles.productTable}>
			<Table
				columns={[{ key: 'name' }, { key: 'price' }]}
				rows={value.rows.map(({ name, price }) => ({
					cells: {
						name,
						price,
					},
				}))}
			/>
		</div>
	);
}

interface ProductTableProps {
	value: {
		rows: { name: string; price: string }[];
	};
}
